export default __webpack_public_path__ + "static/media/WifiOffline.dde20d4b.svg";